export default "__VITE_ASSET__6u$nIgck__"